<template>
  <GrayHexContainer class="py-12">
    <div>
      <RegistrationPrompt
        class="mx-auto"
        button-id="company-size-button-footer"
      />
    </div>
  </GrayHexContainer>
</template>

<script>
import GrayHexContainer from '@/components/GrayHexContainer';
import RegistrationPrompt from '@/components/RegistrationPrompt';

export default {
  components: { GrayHexContainer, RegistrationPrompt },
};
</script>
